import ButtonContainer from "./buttonCotainer";
import VideosContainer from "./videosContainer";

const MainContainer = () => {
  return <div className="maincontainer">
    <ButtonContainer/>
    <VideosContainer/>
  </div>;
};
export default MainContainer;
